import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="section-spacing bg-[#F7FAFC]">
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Card 1 - Empresas - IMAGEM ÚNICA */}
          <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden hover:shadow-md transition-shadow">
            <div className="aspect-[16/9] relative">
              <img 
                src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=600&q=80" 
                alt="Reunião de negócios com clientes"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <span className="caption mb-2 block">Para Empresas</span>
              <h3 className="heading-3 mb-2">Solicite uma proposta</h3>
              <p className="text-[#64748B] mb-5 text-sm">
                Descubra como podemos ajudar sua empresa a alcançar melhores resultados.
              </p>
              <Link to="/contato" className="btn-primary">
                Fale Conosco
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>

          {/* Card 2 - Carreiras - IMAGEM ÚNICA */}
          <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden hover:shadow-md transition-shadow">
            <div className="aspect-[16/9] relative">
              <img 
                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&q=80" 
                alt="Jovens profissionais colaborando"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <span className="caption mb-2 block">Para Talentos</span>
              <h3 className="heading-3 mb-2">Construa sua carreira</h3>
              <p className="text-[#64748B] mb-5 text-sm">
                Faça parte de uma equipe que valoriza excelência e desenvolvimento.
              </p>
              <Link to="/trabalhe-conosco" className="btn-secondary">
                Enviar Currículo
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
